import { closeSearchSuggest } from './_header-search';

const menu = $('.js-menu');
const body = $('body');
let positionScroll;

$('.js-openMenu').on('click', function() {
	const _this = $(this);

	menu.toggleClass('is_open');
	_this.toggleClass('is_active');
	body.toggleClass('menu_open');

	if (!body.hasClass('menu_open')) {
		$('body, html').animate({scrollTop: positionScroll}, 0);
		closeSearchSuggest();
	}
});

// ios баг, запоминаем позицию окна при скролле, чтобы при закрытии меню делать скролл к этой позиции
$(window).on('scroll', function() {
    if (!$('.menu_open').length > 0) {
        positionScroll = $(window).scrollTop();
    }
});
